module.exports = __webpack_public_path__ + "static/img/back.e2809d89.png";